var QS = document.querySelector.bind(document);
window.fontsize = 100;
export var ratioEdge = {
    current: 0.64,
};
export function setRatioEdge2(ratio) {
    ratioEdge.current = ratio;
}
function setMeta(scale) {
    var head = document.head;
    var metaContent = "width:device-width," +
        "initial-scale=" +
        scale +
        ",maximum-scale=" +
        scale +
        ",minimum-scale=" +
        scale +
        ",user-scalable=no";
    var metaElem = QS("meta[name=\"viewport\"]") ||
        document.createElement("meta");
    metaElem.name = "viewport";
    metaElem.setAttribute("content", metaContent);
    if (metaElem.parentElement !== head) {
        head.appendChild(metaElem);
    }
}
var scale = 1;
var skip = false;
var prevWidth = 0;
export function recalc2() {
    if (prevWidth === window.innerWidth) {
        return;
    }
    if (skip) {
        skip = false;
        return;
    }
    var docEl = document.documentElement;
    var dpr = window.devicePixelRatio || 1;
    if (dpr > 3) {
        dpr = 3;
    }
    if (scale !== 1 / dpr) {
        skip = true;
    }
    scale = 1 / dpr;
    docEl.setAttribute("data-dpr", "" + dpr);
    setMeta(scale);
    if (window.innerWidth !== docEl.offsetWidth) {
        dpr = 1;
        scale = 1;
        skip = true;
        setMeta(scale);
    }
    var width = window.innerWidth;
    var height = window.innerHeight;
    window.docElwidth = width;
    window.docElheight = height;
    console.log("o:", window.orientation, "w:", width, "h:", height);
    var w = width;
    if (width / height >= ratioEdge.current) {
        w = height * ratioEdge.current;
    }
    var font = (w / 750) * 100;
    docEl.style.fontSize = font + "px";
    var realFont = window.getComputedStyle(docEl).fontSize;
    realFont = parseFloat(realFont.replace("px", ""));
    if (realFont !== font) {
        console.log("realFont", realFont, "expectedFont", font);
        font = (font * font) / realFont;
        docEl.style.fontSize = font + "px";
    }
    window.fontsize = font;
    prevWidth = window.innerWidth;
}
export function listen2() {
    recalc2();
    var resizeEvt = "orientationchange" in window ? "orientationchange" : "resize";
    window.addEventListener(resizeEvt, recalc2, false);
    var handlePageShow = function (e) {
        if (e.persisted) {
            recalc2();
        }
    };
    window.addEventListener("pageshow", handlePageShow);
    return function () {
        window.removeEventListener(resizeEvt, recalc2, false);
        window.removeEventListener("pageshow", handlePageShow);
    };
}
//# sourceMappingURL=initRem2.js.map